import { memo, useMemo } from 'react'
import type { FC } from 'react'
import styled from 'styled-components'
import { useModal, useTranslator } from '@/hooks'
import { Img } from '@/components'
import { MODALS } from '@/context'
import { mq,presets, vw } from '@/styles'
import { STORE_ABBR } from '@/utils'

const iconSearch = (fillColor = 'darkred') => ({
  type: 'svg' as const,
  src: `/images/svg/i--search${fillColor === '--color-white' ? '--white' : `-${STORE_ABBR}`}.svg`,
  alt: 'Logo',
  size: { width: 16, height: 16 }
})

type TypeButtonTriggerSearch = {
  fillColor: '--color-white' | '--color-text'
}

export const ButtonTriggerSearch: FC<TypeButtonTriggerSearch> = memo(({ fillColor = '--color-white' }) => {
  const { toggle: toggleSearch } = useModal(MODALS.SEARCH)
  const { t } = useTranslator()
  const color = useMemo(() => fillColor, [fillColor])

  return (
    <Button onClick={toggleSearch} type='button' aria-haspopup='dialog' className='btn btn--search' aria-controls={MODALS.SEARCH}>
      <Img media={iconSearch(color)} fill={false} />
      <span>{t('search.what_are_you_looking_for')}</span>
    </Button>
  )
})


const Button = styled.button`

  img {
    object-fit: contain;
    width: ${vw(14, 'mobile')};

    ${mq.greaterThan('nexus7')} {
      width: ${vw(14, 'tablet')};
    }

    ${mq.greaterThan('tablet')} {
      width: ${vw(16, 'desktop')};
    }

    ${mq.greaterThan('desktop')} {
      width: 16px;
    }
  }

  &.btn--search {
    >span {
      ${presets.font14Search}
      font-family: var(--font-basier-circle);
      display: none;
      min-width: unset;

      ${mq.greaterThan('tablet')} {
        display: inline-block;
        min-width: ${vw(150, 'desktop')};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      ${mq.greaterThan('desktop')} {
        min-width: 150px;
      }
    }
  }

`
